import React from "react";
import { useIntl } from "react-intl";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";

import { messages } from "../../PostProduction.messages";
import styles from "./Slide3.module.scss";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";
import { useBlocks } from "@jelly/lesson";
import config from "appConfig";

export const Slide3: React.FC = () => {
  const { formatMessage } = useIntl();
  const block = useBlocks();

  return (
    <SimpleLayoutView>
      <div className={styles.root}>
        <div className={styles.rightComponent}>
          {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
          <SpatialCarousel showBreadcrumbs>
            {[
              <div key={1} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G4_P4_S3_S1_Title)}</h3>
                <ul>
                  <li>{formatMessage(messages.G4_P4_S3_S1_Description_1)}</li>
                  <li>{formatMessage(messages.G4_P4_S3_S1_Description_2)}</li>
                </ul>
                <block.image src={`${config.STATIC_ASSETS_URL}/lms/guide/guide04/postproduction/pp1.jpg`}></block.image>
              </div>,
              <div key={2} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G4_P4_S3_S2_Title)}</h3>
                <ul>
                  <li>{formatMessage(messages.G4_P4_S3_S2_Description_1)}</li>
                  <li>{formatMessage(messages.G4_P4_S3_S2_Description_2)}</li>
                  <li>{formatMessage(messages.G4_P4_S3_S2_Description_3)}</li>
                  <li>{formatMessage(messages.G4_P4_S3_S2_Description_4)}</li>
                </ul>

                <block.image src={`${config.STATIC_ASSETS_URL}/lms/guide/guide04/postproduction/pp2.jpg`}></block.image>
              </div>,
              <div key={3} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G4_P4_S3_S3_Title)}</h3>
                <div className={styles.listWrapper}>
                  <h5>{formatMessage(messages.G4_P4_S3_S3_Subtitle1)}</h5>
                  <ul>
                    <li>{formatMessage(messages.G4_P4_S3_S3_Description_1)}</li>
                    <li>{formatMessage(messages.G4_P4_S3_S3_Description_2)}</li>
                    <li>{formatMessage(messages.G4_P4_S3_S3_Description_3)}</li>
                    <li>{formatMessage(messages.G4_P4_S3_S3_Description_4)}</li>
                    <li>{formatMessage(messages.G4_P4_S3_S3_Description_5)}</li>
                  </ul>
                </div>

                <block.image
                  src={`${config.STATIC_ASSETS_URL}/lms/guide/guide04/postproduction/pp3.jpg`}
                  onHoverAction={[
                    {
                      type: "changeOptions",
                      options: {
                        src: `${config.STATIC_ASSETS_URL}/lms/guide/guide04/postproduction/pp3_hover.jpg`,
                      },
                    },
                  ]}
                ></block.image>
              </div>,
              <div key={4} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G4_P4_S3_S4_Title)}</h3>
                <div className={styles.listWrapper}>
                  <h5>{formatMessage(messages.G4_P4_S3_S4_Subtitle1)}</h5>
                  <ul>
                    <li>{formatMessage(messages.G4_P4_S3_S4_Description_1)}</li>
                    <li>{formatMessage(messages.G4_P4_S3_S4_Description_2)}</li>
                  </ul>
                </div>
                <div className={styles.infoxBox}>
                  <block.infoBox text={formatMessage(messages.G4_P4_S3_S4_Disclaimer)} compact={true} />
                </div>
              </div>,
              <div key={5} className={styles.carouselItem}>
                <h3>{formatMessage(messages.G4_P4_S3_S5_Title)}</h3>
                <div className={styles.listWrapper}>
                  <h5>{formatMessage(messages.G4_P4_S3_S5_Subtitle1)}</h5>
                  <ul>
                    <li>{formatMessage(messages.G4_P4_S3_S5_Description_1)}</li>
                    <li>{formatMessage(messages.G4_P4_S3_S5_Description_2)}</li>
                  </ul>
                  <h5>{formatMessage(messages.G4_P4_S3_S5_Subtitle2)}</h5>
                  <ul>
                    <li>{formatMessage(messages.G4_P4_S3_S5_Description_3)}</li>
                  </ul>
                </div>
                <block.image
                  src={`${config.STATIC_ASSETS_URL}/lms/guide/guide04/postproduction/pp5.jpg`}
                  onHoverAction={[
                    {
                      type: "changeOptions",
                      options: {
                        src: `${config.STATIC_ASSETS_URL}/lms/guide/guide04/postproduction/pp5_hover.jpg`,
                      },
                    },
                  ]}
                ></block.image>
              </div>,
            ]}
          </SpatialCarousel>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
